export default __webpack_public_path__ + "static/media/managing-platform-bms.87bfbf59.svg";